module.exports = __webpack_public_path__ + "img/ico_tab3_coinstore2@3x.f19a39a6.png";